import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["queryButton", "table", "recordCount"]

  connect() {
    if (this.hasQueryButtonTarget) {
      this.queryButtonTarget.disabled = false
      this.queryButtonTarget.textContent = "查询"
    }
    if (!this.hasTableTarget) return
    const table = this.tableTarget
    const columns = Array.from(table.querySelectorAll(".income-labels th")).map(header => ({
      data: header.dataset.column,
      orderable: header.dataset.orderable === "true",
      searchable: false,
      className: header.className
    }))

    this.datatable = $(table).DataTable({
      processing: true,
      serverSide: true,
      searching: false,
      pageLength: 50,
      lengthMenu: [25, 50, 100],
      autoWidth: false,
      colReorder: false,
      ajax: {
        url: table.dataset.source,
        dataSrc: json => {
          if (this.hasRecordCountTarget) {
            this.recordCountTarget.textContent = `共 ${Number(json.recordsFiltered).toLocaleString("zh-CN")} 条 · 横向滚动查看全部指标`
          }
          return json.data
        }
      },
      columns,
      order: [],
      pagingType: "full_numbers",
      dom: "<'data-tables-toolbar'l><'income-table-scroll'tr><'card-footer d-flex flex-wrap justify-content-between align-items-center gap-2 py-3'ip>",
      language: {
        emptyTable: "当前筛选条件下暂无项目数据，请调整筛选条件。"
      },
      createdRow: (row, data) => {
        Array.from(row.cells).forEach((cell, index) => { cell.className = data.cell_classes[index] })
      }
    })
    const scroll = this.element.querySelector(".income-table-scroll")
    scroll.tabIndex = 0
    scroll.setAttribute("role", "region")
    scroll.setAttribute("aria-label", "项目毛利明细，可横向滚动")
    this.beforeCache = () => this.destroyTable()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.destroyTable()
  }

  destroyTable() {
    if (!this.datatable) return
    this.datatable.settings()[0].jqXHR?.abort()
    this.datatable.destroy()
    this.datatable = null
    this.tableTarget.querySelector("tbody").replaceChildren()
  }

  changeCompany(event) {
    const form = event.target.form
    if (!form) return
    form.querySelectorAll("[data-income-dependent]").forEach(field => { field.disabled = true })
    form.requestSubmit()
  }

  submit() {
    if (!this.hasQueryButtonTarget) return
    this.queryButtonTarget.disabled = true
    this.queryButtonTarget.textContent = "查询中…"
  }
}
